<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>Reboot Management</gg-card-header>
        <gg-card-text class="pa-4">
          <v-alert type="warning" dense>
            Warning: a server reboot will immediately cause your server and any dependent services to become unavailable.
            This functionality should be used with extreme caution!
          </v-alert>

          <v-checkbox
            label="I understand this will restart my server immediately."
            v-model="model.checkbox"
          ></v-checkbox>

          <gg-btn
            color="primary"
            class="ml-0"
            :disabled="!model.checkbox || button.loading"
            :loading="button.loading"
            @click="reboot"
          >
            Reboot
          </gg-btn>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DServerReboot',
  data: () => ({
    model: {
      checkbox: false
    },
    button: {
      loading: false
    }
  }),
  methods: {
    ...mapActions(['vserver_reboot', 'reportError', 'reportSuccess']),
    async reboot () {
      this.button.loading = true

      try {
        await this.vserver_reboot()
        this.model.checkbox = false
        this.button.loading = false
        this.reportSuccess('Server Successfully Rebooted')
      } catch (e) {
        this.button.loading = false
        this.reportError('Unable to reboot server')
      }
    }
  }
}
</script>
